import { DataObjectOutlined } from '@mui/icons-material'
import { IconButton, ListItemIcon, ListItemText, MenuItem, Tooltip } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { Nullish } from '@omnea-app/packages/universal/utility-types/utilityTypes'
import { CopyEntityType } from '../CopyIdButton/CopyIdButton'

type Props = {
  entityType: CopyEntityType
  inDropdownWithIcon?: boolean
  getConfig?: () => unknown
  config?: Nullish<object>
}

export const CopyConfigButton: React.FC<Props> = ({ config, getConfig, entityType, inDropdownWithIcon = false }) => {
  const { user } = useAuthenticatedUser()
  const { t } = useTranslation('common', { keyPrefix: 'copy-button' })
  const entityLabel = t(`entity.${entityType}`)
  const title = t('copy-config', { entityLabel })

  if (!user.isOmnean) return null
  if (!config && !getConfig) return null

  const handleClick = async () => {
    try {
      const resolved = getConfig ? getConfig() : config
      if (process.env.NODE_ENV === 'development') {
        // oxlint-disable-next-line no-console
        console.log(JSON.stringify(resolved, null, 2))
      }
      await navigator.clipboard.writeText(JSON.stringify(resolved, null, 2))
      enqueueSnackbar(t('copy-config-success', { entityLabel }), { variant: 'success' })
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // oxlint-disable-next-line no-console
        console.error(error)
      }
      enqueueSnackbar(t('copy-config-error', { entityLabel }), { variant: 'error' })
    }
  }

  if (inDropdownWithIcon) {
    return (
      <MenuItem onClick={() => void handleClick()}>
        <ListItemIcon>
          <DataObjectOutlined />
        </ListItemIcon>
        <ListItemText primary={title} />
      </MenuItem>
    )
  }
  return (
    <Tooltip title={title}>
      <IconButton onClick={() => void handleClick()}>
        <DataObjectOutlined />
      </IconButton>
    </Tooltip>
  )
}
